<template>
  <VNavigationDrawer
    app
    v-bind="modePreset[cMode]"
    :mobile-breakpoint="$vuetify.breakpoint.mobileBreakpoint"
    @input="updateMode"
  >
    <RouterLink
      v-slot="{ navigate }"
      :to="mainTo"
      custom
    >
      <div
        role="link"
        @click="navigate"
      >
        <VListItem
          :style="{ height: ($vuetify.breakpoint.mdAndUp ? '63px' : '') }"
          class="px-2"
          link
        >
          <VListItemAvatar>
            <VIcon v-if="!mainAvatarImage">
              {{ mainAvatarIcon }}
            </VIcon>
            <ImageWrapper
              v-else
              :src="mainAvatarImage"
            />
          </VListItemAvatar>

          <VListItemContent>
            <VListItemTitle>{{ mainTitle }}</VListItemTitle>
          </VListItemContent>
        </VListItem>
      </div>
    </RouterLink>

    <VDivider />

    <NavList :list="list" />
  </VNavigationDrawer>
</template>

<script>
import NavList from '@/components/layouts/Sidebar/NavList'
import { ImageWrapper } from '@/components/base'


export default {
  components: {
    NavList,
    ImageWrapper
  },
  props: {
    value: {
      type: Boolean,
      default: true
    },
    mainTitle: {
      type: String,
      default: 'Vue Client'
    },
    mainAvatarIcon: {
      type: String,
      default: 'mdi-vuetify'
    },
    mainAvatarImage: {
      type: String,
      default: require('@/assets/images/favicon.png')
    },
    mainTo: {
      type: [String, Object],
      default: '/'
    },
    /**
     * List of item to be displayed on sidebar
     * @example
     * [
        {
          title: {String} Section title,
          divider: {Boolean} Section divider,
          debug: {Boolean} Shows only on debug,
          authenticated: {Boolean} Shows only on authenticated,
          roles: {Array} Shows only on specified roles,
          permissions: {Array} Shows only on specified permissions,
          items: {Array} [Required] Menu items
          [
            {
              title: {String} [Required] Group / Item title,
              icon: {String} Group / Item icon,
              custom: {String} Custom title in HTML string,
              debug: {Boolean} Shows only on debug,
              authenticated: {Boolean} Shows only on authenticated,
              roles: {Array} Shows only on specified roles,
              permissions: {Array} Shows only on specified permissions,
              child: {Array} Second level menu
              [
                {
                  title: {String} [Required] Child title,
                  icon: {String} Child icon,
                  custom: {String} Custom title in HTML string,
                  debug: {Boolean} Shows only on debug,
                  authenticated: {Boolean} Shows only on authenticated,
                  roles: {Array} Shows only on specified roles,
                  permissions: {Array} Shows only on specified permissions,
                  ... [@see https://vuetifyjs.com/en/api/v-list-item/#props]
                },
                ...
              ]
              ... [@see https://vuetifyjs.com/en/api/v-list-item/#props]
            },
            ...
          ]
        },
        ...
      ]
     */
    list: {
      type: Array,
      default: () => [
        {
          title: 'Examples',
          debug: true,
          items: [
            {
              title: 'Sidebar Example',
              icon: 'mdi-page-layout-sidebar-left',
              child: [
                {
                  title: 'Custom HTML',
                  icon: 'mdi-palette',
                  custom: '<span style="color: red">RED TEXT</span>'
                },
                {
                  title: 'External Link',
                  icon: 'mdi-google',
                  href: 'https://www.google.com',
                  target: '_blank'
                },
                {
                  title: 'Authenticated Only',
                  icon: 'mdi-account-check',
                  authenticated: true
                },
                {
                  title: 'Roles (A & B)',
                  icon: 'mdi-account-eye',
                  roles: ['A', 'B']
                },
                {
                  title: 'Permissions',
                  icon: 'mdi-account-key',
                  permissions: ['Permission_1', 'Permission_2']
                }
              ]
            }
          ]
        }
      ]
    }
  },
  data () {
    return {
      modePreset : {
        hidden: {
          value: false,
          miniVariant: false,
          expandOnHover: false
        },
        show:  {
          value: true,
          miniVariant: false,
          expandOnHover: false
        },
        mini:  {
          value: true,
          miniVariant: true,
          expandOnHover: true
        },
      }
    }
  },
  computed: {
    cMode () {
      if (this.$vuetify.breakpoint.mobile) {
        return this.value ? 'show' : 'hidden'
      }
      else {
        return this.value ? 'show' : 'mini'
      }
    }
  },
  methods: {
    updateMode (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style>
  .v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
    margin-right: 10px;
  }

  .v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item {
    padding-left: 50px;
  }
</style>
